import { observer } from 'mobx-react-lite'

import Typography from '@ui/Typography'

import * as styles from './IncomingCallInvitationText.css'
import type { IncomingCallInvitation, IncomingCallVia } from './IncomingCallUiStore'
import Via from './Via'

interface IncomingCallInvitationTextProps {
  invitation: IncomingCallInvitation
  via: IncomingCallVia | null
}

const IncomingCallInvitationText = ({
  invitation,
  via,
}: IncomingCallInvitationTextProps) => {
  return (
    <Typography
      variant="callout"
      color="textSecondary"
      fontWeight="regular"
      className={styles.root}
    >
      <span>
        {invitation.text}
        <Via via={via} />
      </span>
    </Typography>
  )
}

export default observer(IncomingCallInvitationText)
